 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"winterGame": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"winterGame": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({}[chunkId]||chunkId) + "." + {"chunk-26c7f780":"3028c0f5","chunk-389a998a":"3c0a6675","chunk-0605c594":"e29c21e9","chunk-1159728d":"9b22f57d","chunk-16cbb1d0":"66524608","chunk-264b182b":"5888891c","chunk-2753f08e":"4d7bde17","chunk-2d216257":"5e731856","chunk-78781484":"1cd744e4","chunk-c679d2f8":"e4cbc898","chunk-08358d5b":"6c18c6c2","chunk-41997df9":"3fe6dc45","chunk-4b306908":"600e118e","chunk-599fb80a":"f7ff724b","chunk-660f7592":"80229a02","chunk-6908e4fe":"3d9a80fa","chunk-753ba9ce":"4dc84def","chunk-7a83bcf0":"3ba2ac97","chunk-7f0e2ba1":"5f6e2c52","chunk-3f9cc0c7":"fa628dfc","chunk-4604810a":"afdfba86","chunk-470753c6":"f7e51cd8","chunk-770a3d0c":"768e3a11","chunk-455972e3":"f61c8fc3","chunk-66609bec":"fbff9cc3","chunk-5ab8e2a1":"89b26cf7","chunk-68875db4":"2e253d3f","chunk-7487fbc8":"d8a585ea","chunk-7f68e2f4":"a6eb0b55","chunk-9d92b61a":"dee8d9ec","chunk-a4403ad6":"b8480bc2","chunk-b692fb7c":"0b16fde9","chunk-6f8ea184":"a0ef7ef1","chunk-205a2203":"b6e74749","chunk-2392d38c":"631e4541","chunk-2618e52a":"ae5929d3","chunk-3cada1c6":"12d0c86f","chunk-5549c30d":"3b35ecd1","chunk-67a4f2f1":"7112ee4b","chunk-bfce1588":"695c4f3c","chunk-e0175948":"a9b6f122","chunk-da433e4e":"a40429ff","chunk-2adf2bb9":"382c3a5f","chunk-2d0c5184":"bda7a59a","chunk-42981432":"7e5e7529","chunk-47c9b0de":"46360f1c","chunk-5e9d40a2":"2a6b5a47","chunk-da1a9f22":"647c4e46"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0605c594":1,"chunk-1159728d":1,"chunk-16cbb1d0":1,"chunk-264b182b":1,"chunk-2753f08e":1,"chunk-78781484":1,"chunk-08358d5b":1,"chunk-41997df9":1,"chunk-4b306908":1,"chunk-599fb80a":1,"chunk-660f7592":1,"chunk-6908e4fe":1,"chunk-753ba9ce":1,"chunk-7a83bcf0":1,"chunk-7f0e2ba1":1,"chunk-3f9cc0c7":1,"chunk-4604810a":1,"chunk-770a3d0c":1,"chunk-455972e3":1,"chunk-66609bec":1,"chunk-5ab8e2a1":1,"chunk-68875db4":1,"chunk-7487fbc8":1,"chunk-7f68e2f4":1,"chunk-9d92b61a":1,"chunk-a4403ad6":1,"chunk-b692fb7c":1,"chunk-205a2203":1,"chunk-2392d38c":1,"chunk-2618e52a":1,"chunk-3cada1c6":1,"chunk-5549c30d":1,"chunk-67a4f2f1":1,"chunk-bfce1588":1,"chunk-e0175948":1,"chunk-da433e4e":1,"chunk-2adf2bb9":1,"chunk-42981432":1,"chunk-47c9b0de":1,"chunk-5e9d40a2":1,"chunk-da1a9f22":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({}[chunkId]||chunkId) + "." + {"chunk-26c7f780":"31d6cfe0","chunk-389a998a":"31d6cfe0","chunk-0605c594":"de29b3d9","chunk-1159728d":"686d9e90","chunk-16cbb1d0":"e95fe8e1","chunk-264b182b":"e7b8ffe5","chunk-2753f08e":"25b78ff8","chunk-2d216257":"31d6cfe0","chunk-78781484":"2cf6d010","chunk-c679d2f8":"31d6cfe0","chunk-08358d5b":"01143018","chunk-41997df9":"a9eacd92","chunk-4b306908":"ee459989","chunk-599fb80a":"f1cf571a","chunk-660f7592":"fb1de830","chunk-6908e4fe":"e9c5970b","chunk-753ba9ce":"34642513","chunk-7a83bcf0":"a92300b1","chunk-7f0e2ba1":"477ba212","chunk-3f9cc0c7":"d471823c","chunk-4604810a":"7ca9c3ac","chunk-470753c6":"31d6cfe0","chunk-770a3d0c":"b7c1a194","chunk-455972e3":"b80e947b","chunk-66609bec":"fe53e899","chunk-5ab8e2a1":"07505793","chunk-68875db4":"21cefd39","chunk-7487fbc8":"34dbeb3f","chunk-7f68e2f4":"73a7d99a","chunk-9d92b61a":"ce0c1ed8","chunk-a4403ad6":"681ed568","chunk-b692fb7c":"16721c54","chunk-6f8ea184":"31d6cfe0","chunk-205a2203":"12731415","chunk-2392d38c":"76313ca8","chunk-2618e52a":"edf528cd","chunk-3cada1c6":"870470af","chunk-5549c30d":"467527e1","chunk-67a4f2f1":"6f04fa59","chunk-bfce1588":"89e91e03","chunk-e0175948":"66d39495","chunk-da433e4e":"3e8306a4","chunk-2adf2bb9":"f49abb0d","chunk-2d0c5184":"31d6cfe0","chunk-42981432":"d2cea4aa","chunk-47c9b0de":"014538a9","chunk-5e9d40a2":"8101b0ba","chunk-da1a9f22":"7201b324"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//statics.classba.cn/prod/pad_dl_evaluation/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([22,"chunk-vendors","chunk-common"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
